import { defaultItemSettings, socialLinksData } from './_itemData.js';
import { safeUrl, fetchJsonItems } from './_utils.js';
/** Render JSON profiles after the DOM is ready; options override shared image/icon defaults. */
export function loadAndRenderItems(
  jsonUrl = '/assets/json/itemList.json',
  targetSelector = '.c-data-area__list',
  options = {}
) {
  const dataAreaList = document.querySelector(targetSelector);
  if (!dataAreaList) {
    return;
  }
  const settings = { ...defaultItemSettings, ...options };
  fetchJsonItems(jsonUrl)
    .then((items) => {
      const fragment = document.createDocumentFragment();

      items.forEach((itemData) => {
        const articleElement = createItemArticle(itemData, settings);
        if (articleElement) {
          fragment.appendChild(articleElement);
        }
      });
      dataAreaList.replaceChildren(fragment);
    })
    .catch((error) => {
      console.error('Error loading JSON:', error);
      dataAreaList.innerHTML =
        '<p class="json-load-error">データの読み込みに失敗しました。時間をおいてお試しください。</p>';
    });
}

function createItemArticle(itemData, settings) {
  if (!itemData || typeof itemData !== 'object' || !itemData.id || !itemData.name) {
    return null;
  }

  const article = document.createElement('article');
  article.id = `item${itemData.id}`;
  article.className = 'c-data-area__article';
  const figure = document.createElement('figure');
  figure.className = 'item-image';
  const image = document.createElement('img');
  image.src = safeUrl(itemData.image) || safeUrl(settings.defaultImageUrl);
  image.alt = itemData.name;
  image.width = settings.defaultImageWidth;
  image.height = settings.defaultImageHeight;
  image.loading = 'lazy';
  figure.appendChild(image);
  article.appendChild(figure);
  const name = document.createElement('h3');
  name.textContent = itemData.name || '';
  article.appendChild(name);
  const nameEn = document.createElement('p');
  nameEn.textContent = itemData.nameEn || '';
  article.appendChild(nameEn);
  const birthDay = document.createElement('p');
  birthDay.textContent = itemData.birthDay || '';
  article.appendChild(birthDay);
  const itemUrl = safeUrl(itemData.url);
  if (itemUrl) {
    const url = document.createElement('p');
    const linkElement = document.createElement('a');
    linkElement.className = 'external';
    linkElement.href = itemUrl;
    linkElement.target = '_blank';
    linkElement.rel = 'noopener noreferrer';
    linkElement.textContent = itemData.url;
    url.appendChild(linkElement);
    article.appendChild(url);
  }

  const socialLinkItems = [];
  socialLinksData.forEach((social) => {
    const socialUrl = safeUrl(itemData[social.name]);
    if (socialUrl) {
      const listItem = document.createElement('li');
      const linkElement = document.createElement('a');
      linkElement.href = socialUrl;
      linkElement.target = '_blank';
      linkElement.rel = 'noopener noreferrer';

      const icon = document.createElement('img');
      icon.alt = `${social.label || social.name}へのリンク`;
      icon.src = `${settings.socialIconBasePath}${social.icon}`;
      icon.width = 24;
      icon.height = 24;

      linkElement.appendChild(icon);
      listItem.appendChild(linkElement);
      socialLinkItems.push(listItem);
    }
  });
  if (socialLinkItems.length) {
    const socialLinksList = document.createElement('ul');
    socialLinksList.classList.add('social-links-list');

    socialLinkItems.forEach((item) => {
      socialLinksList.appendChild(item);
    });
    article.appendChild(socialLinksList);
  }
  const message = document.createElement('p');
  message.textContent = itemData.message || '';
  article.appendChild(message);

  return article;
}
